<div class="bn-unauthorized">
  <div class="bn-unauthorized__container">
    <img
      alt="Unauthorized"
      class="bn-unauthorized__container__image"
      src="/assets/web-ui/images/bunny-access-denied.svg"
      [ngStyle]="{
        'width.px': 350,
      }" />
    <div class="bn-unauthorized__container__title">Users don't match!</div>
    <div class="bn-unauthorized__container__description">
      Requested user
      <code>{{ decodedUserFromQueryParams }}</code>
      and currently logged-in user
      <code>{{ (userDetailsService.getUserDetails() | async)?.Email }}</code>
      don't match!
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <bn-web-ui-button
        itemStyle="secondary"
        size="lg"
        (click)="logoutAndPrefillLoginData()">
        Switch User
      </bn-web-ui-button>
      <span class="ms-4 me-1">or </span>
      <bn-web-ui-button
        itemStyle="link"
        size="lg"
        (click)="navigateToTargetPage()">
        Cancel
      </bn-web-ui-button>
    </div>
  </div>
</div>
